import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ClientLogPayload } from "@src/services/client-logs.service";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the client-logs endpoint.
 * Uses keepalive so the log is sent even if the page unloads mid-flight.
 * Applies timestamp and url defaults before sending.
 */
export function buildClientLogsConfig(payload: ClientLogPayload): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.CLIENT_LOGS,
    keepalive: true,
    body: {
      ...payload,
      timestamp: payload.timestamp || new Date().toISOString(),
      url: payload.url || (typeof window !== "undefined" ? window.location.href : ""),
    },
  };
}
